import React from 'react';
import { observer } from 'mobx-react';
import user_top_navbar_icon from '../../../assets/images/user_top_navbar_icon.svg';
import user_arrow_top_navbar_icon from '../../../assets/images/user_arrow_top_navbar_icon.svg';
import edit_top_navbar_icon from '../../../assets/images/edit_top_navbar_icon.svg';
import sign_out_top_navbar_icon from '../../../assets/images/sign_out_top_navbar_icon.svg';

import store from '../../../stores/store';
let app;
if (window.require) {
    app = window.require('electron').remote.app;
}

const ProfileMenu = observer(
    class ProfileMenu extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                showDropDownMenu: false,
            };
        }

        profileView = () => {
            this.props.history.push('/profile');
        };

        enableDropdown = () => {
            this.setState({ showDropDownMenu: !this.state.showDropDownMenu });
        };

        closeDropdown = () => {
            this.setState({ showDropDownMenu: false });
        };

        signOutHandler = () => {
            if (window.offlineApiExtension && window.require) {
                store.user.showCloseAppModal();
            } else {
                store.user.logout(this.props.history);
            }
        };

        render() {
            if (!store.user.data) {
                return <div>no user</div>;
            }
            const firstName = store.user.data.FirstName;
            const surname = store.user.data.Surname;

            return (
                <div
                    className={this.state.showDropDownMenu ? 'dropdown show' : 'dropdown'}
                    onClick={() => {
                        this.enableDropdown();
                    }}
                    onMouseLeave={() => {
                        this.closeDropdown();
                    }}
                >
                    <div
                        id="userDropdownMenuButton"
                        className="btp-menu-item"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded={this.state.showDropDownMenu}
                    >
                        <img src={user_top_navbar_icon} alt="User" className="user-pic-menu" />
                        <br />
                        <span className="profile-username">
                            {firstName} {surname}
                        </span>
                        <img
                            src={user_arrow_top_navbar_icon}
                            alt="User drop-down menu"
                            className="user-dropdown-icon"
                        />
                    </div>
                    <div
                        className="dropdown-menu dropdown-menu-right user-drop-down-menu"
                        aria-labelledby="userDropdownMenuButton"
                    >
                        {/*
                        <img
                            src={store.user.localAvatarUrl}
                            alt="avatar"
                            className="rounded-circle mx-auto d-block user-pic-menu mt-1"
                        />                         
                        <h6 className="text-center p-2">
                            {firstName} {surname}
                        </h6>                         
                        <div className="dropdown-divider" />
                        */}
                        <a className="btp-menu-item" onClick={this.profileView}>
                            <img src={edit_top_navbar_icon} alt="View profile" />
                            <br />View profile
                        </a>
                        <a className="btp-menu-item" onClick={this.signOutHandler}>
                            <img src={sign_out_top_navbar_icon} alt="Sign out" />
                            <br />Sign out
                        </a>
                        <div className="dropdown-divider" />
                        {window.require && (
                            <div className="text-center version">Version: {app.getVersion()}</div>
                        )}
                    </div>
                </div>
            );
        }
    },
);

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/AppMenu/ProfileMenu.js